import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

// Thunk to handle file upload
export const importPartnerApi = createAsyncThunk(
  'importPartner/uploadExcelFile',
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post(
        '/importPartner',
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const importPartnerSlice = createSlice({
  name: "importPartner",
  initialState: {
    data: null,
    errors: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(importPartnerApi.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(importPartnerApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "succeeded";
      })
      .addCase(importPartnerApi.rejected, (state, action) => {
        state.errors = action.payload;
        state.status = "failed";
      });
  },
});

export default importPartnerSlice.reducer;
